import { prefixPath } from '../../utils/helpers';

import Urls from '../../utils/urls';

const RightButtons = ({ theme }:{theme:string}) => {
  const imgSubPath = window.location.origin;
  const addImg = imgSubPath + prefixPath(`/img/${theme}/Add Workspace.png`);
  return (
    <div className="col-lg-6 col-xl-6 col-sm-12 col-xs-12 cursor button-add">
        <div className="d-flex justify-content-end">
            <a href={Urls.getSelectProtocolUrl()} style={{ textDecoration: 'none' }}>
                <button type="button" className="ms-3 btn comingSoon">
                    <img src={addImg} alt="" className="me-2" />
                     Buy
                    {' '}
                    Subscription
                </button>
            </a>
        </div>
    </div>
  );
};

export default RightButtons;